import React from "react";
// import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  AppBar,
  IconButton,
} from "@material-ui/core";
import MailIcon from "@material-ui/icons/Mail";

const HeaderEmpresas = props => {
  // console.log(props);

  return (
    <AppBar position="static">
      <div className="blue darken-4">
        <h6 style={{ float: "left", padding: "5px 10px" }}>
          Empresas
        </h6>
        <div style={{ float: "right" }}>
          <IconButton color="inherit">
            <MailIcon />
          </IconButton>
        </div>
      </div>
    </AppBar>
  );
};

const mapStateToProps = state => {
  // console.log(state);
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  };
};

export default connect(mapStateToProps)(HeaderEmpresas);
